import React from 'react';
import { Dropdown, Typography, Icon, Menu } from 'antd';
import { autoUpdatePeriods } from '../../constants/autoUpdatePeriods';
import styles from './SelectUpdatePeriod.module.scss';

const { Text } = Typography;

const Overlay = ({ onClick, period, ...props }) => {
  return (
    <Menu
      {...props}
      onClick={onClick}
      selectedKeys={[period]}
    >
      {Object.values(autoUpdatePeriods).map((val) => (
        <Menu.Item key={val.key}>{val.value}</Menu.Item>
      ))}
    </Menu>
  );
};

const SelectUpdatePeriod = ({ period, onPeriodClick }) => {
  return (
    <Dropdown
      overlay={
        <Overlay
          onClick={onPeriodClick}
          period={period}
        />
      }
    >
      <Text className={styles.text}>
        {autoUpdatePeriods[period].value} <Icon type="down" />
      </Text>
    </Dropdown>
  );
};

export default SelectUpdatePeriod;
